import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0caf98bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row logline" }
const _hoisted_2 = { class: "prompt" }
const _hoisted_3 = { class: "result" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.prompt) + _toDisplayString(_ctx.execution.command.command) + " " + _toDisplayString(_ctx.execution.command.args.join(' ')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("pre", { innerHTML: _ctx.output }, null, 8, _hoisted_4)
    ])
  ]))
}